import { DialogProvider } from './dialog.provider';
export * from './dialog.provider';

export const PROVIDERS = [
  DialogProvider
];
